import { createContext, ReactNode, useContext } from "react";
import { ContextType, DataProvider } from "./DataProvider";
import { CharacterProfile } from "../shared/types/CharacterProfile";
import { House } from "../shared/types/House";
import { HouseElement } from "../shared/types/HouseElement";

const CharactersContext = createContext<ContextType<CharacterProfile> | null>(
  null,
);

export const CharactersProvider = ({ children }: { children: ReactNode }) => (
  <DataProvider context={CharactersContext} collection="characters">
    {children}
  </DataProvider>
);

export const useCharacters = () => {
  const context = useContext(CharactersContext);
  if (!context) {
    throw new Error("useCharacters must be used within a CharactersProvider");
  }
  return context;
};